import { useEffect } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import TextInput from "../../../main/components/TextInput";
import { Typography } from "@mui/material";
import { PostUser, User } from "../types";

export const schema = yup.object().shape({
  name: yup.string().required("Nome do usuário é obrigatório"),
});
export type UpdateUserNameData = yup.InferType<typeof schema>;

export const UserNameEditForm = React.forwardRef(
  (
    props: {
      setNewName: (name: string) => void;
      setOpenConfirmNameEditModal: (open: boolean) => void;
      open: boolean;
      setCanEdit: (canEdit: boolean) => void;
      user: User | PostUser;
    },
    ref
  ) => {
    const { setNewName, setOpenConfirmNameEditModal, open, user } = props;

    const formInitialValue = {
      name: user.name,
    };

    const {
      control,
      formState: { errors },
      handleSubmit,
      watch,
    } = useForm({
      defaultValues: formInitialValue,
      resolver: yupResolver(schema),
    });
    const name = user?.name;
    const data = watch();

    useEffect(() => {
      if (name && data.name !== name) {
        props.setCanEdit(true);
      } else {
        props.setCanEdit(false);
      }
    }, [data, open]);

    const onSubmit = (data: UpdateUserNameData) => {
      const newName: string | undefined =
        data.name !== name ? data.name : undefined;
      if (newName) {
        setNewName(newName);
        setOpenConfirmNameEditModal(true);
      }
    };
    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ overflowY: "auto", maxHeight: "80%" }}
        className="d-flex flex-column"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{ fontWeight: "bold", marginTop: "5px", marginBottom: "5px" }}
          >
            Nome do Usuário
          </Typography>
          <TextInput
            control={control}
            errors={errors}
            fieldName="name"
            label=""
          />
        </div>
      </form>
    );
  }
);
